// extracted by mini-css-extract-plugin
export var button = "_8x-0";
export var icon = "_8x-1";